import UdeskLocales from 'UdeskLocales';
import React, { FC, useEffect, useMemo, useState } from 'react';
import { useRequest } from 'ahooks';
import { Select, Space, Tooltip } from 'udesk-ui';
import styled from 'styled-components';
import { InformationOutlined } from '@udesk/icons';
import { getAiModelsFindAll } from 'src/api/aiModels/findAll';
import { SelectProps } from 'antd';
import { AiModelFoundResponse } from 'src/api/types';
import { TypeEnum } from 'Component/pages/semantic-intelligence/intelligent-model/const';

const InfoWrapper = styled.div`
    white-space: pre-wrap;
    color: #1a6eff;
`;

const Tip = styled.div`
    color: rgba(0, 0, 0, 0.45);
`;

interface TemplateProps extends Omit<SelectProps<number>, 'value' | 'onChange'> {
    value?: number;
    onChange?: (v?: AiModelFoundResponse) => void;
    type?: number;
    showTip?: boolean;
}

const Template: FC<TemplateProps> = (props) => {
    const { value, onChange, type, showTip } = props;

    const { data } = useRequest(() => getAiModelsFindAll({ params: { type } }));

    const [model, setModel] = useState<AiModelFoundResponse>();

    useEffect(() => {
        const target = data?.data?.find((d) => d.id === value);
        setModel(target);
    }, [data?.data, value]);

    const typeLabel = useMemo(() => {
        return model?.type === TypeEnum.Conform
            ? /* 是否符合 */ UdeskLocales['current'].pages.tasks.manage.template.checkPoint.detail
                  .components.customModelsSelect.index.whetherItMeetsTheRequirements
            : model?.type === TypeEnum.GradedEvaluation
            ? /* 分档评价 */ UdeskLocales['current'].pages.tasks.manage.template.checkPoint.detail
                  .components.customModelsSelect.index.gradedEvaluation
            : '';
    }, [model]);

    const onInnerChange = (v) => {
        const target = data?.data?.find((d) => d.id === v);
        onChange?.(target);
        setModel(target);
    };

    return (
        <Space>
            <Select
                style={{ width: 300 }}
                value={value}
                onChange={onInnerChange}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => {
                    return ((option?.children?.props?.children ?? '') as string)
                        .toLowerCase()
                        .includes(input.toLowerCase());
                }}
            >
                {(data?.data || []).map((d) => {
                    return (
                        <Select.Option value={d.id!}>
                            <Tooltip
                                title={
                                    <InfoWrapper>
                                        <InformationOutlined style={{ marginRight: 8 }} />
                                        {d.modelDesc}
                                    </InfoWrapper>
                                }
                                placement="right"
                                color="#E6F3FF"
                            >
                                {d.name}
                            </Tooltip>
                        </Select.Option>
                    );
                })}
            </Select>

            {showTip ? <Tip>{typeLabel}</Tip> : null}
        </Space>
    );
};

export default Template;
